import { applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { postMetadataMiddleware } from '../../common/middleware/post-metadata-middleware';
import createRequests from '../../common/services/create-requests';
import createStore from '../../common/services/create-store';
import {
  AppStore,
  ControllerConfig,
  FedopsLogger,
  FlowAPI,
} from '../../common/types';
import { reducers } from '../store/reducers';
import type { RelatedPostsThunkExtraArgs } from '../types';

type CreateReduxStoreParams = {
  fedopsLogger: FedopsLogger;
  isSSR: boolean;
  language: string;
  bundleName: string;
  controllerConfig: ControllerConfig;
  flowAPI: FlowAPI;
};

export function createReduxStore({
  fedopsLogger,
  isSSR,
  language,
  bundleName,
  controllerConfig,
  flowAPI,
}: CreateReduxStoreParams) {
  const { appParams, compId, wixCodeApi } = controllerConfig;
  const { request } = createRequests({
    wixCodeApi,
    bundleName,
    getStore: () => store,
    flowAPI,
  });

  let store: AppStore = undefined!;

  const middleware = [
    thunk.withExtraArgument({
      request,
      wixCodeApi,
      compId,
      appParams,
      fedopsLogger,
      httpClient: flowAPI.httpClient,
    } satisfies RelatedPostsThunkExtraArgs),
    postMetadataMiddleware({ isSSR, language, localizePosts: true }),
  ];
  const initialState = { experiments: flowAPI.essentials.experiments.all() };

  store = createStore(reducers, initialState, applyMiddleware(...middleware));

  return store;
}
